export default class {
    constructor() {
        this.state = {
            dirtyFieldItems: [],
        };
        this.mutations = {
            ADD_DIRTY_FIELD_ITEM(state, item) {
                state.dirtyFieldItems.push(item);
            },
            ADD_FIELD_ITEM(state, {dirtyItem, field}) {
                dirtyItem.fields.push(field)
            },
            EMPTY_DIRTY_ITEM_FIELDS(state) {
                state.dirtyFieldItems = []
            },
        };
        this.actions = {
            addDirtyFieldItem({commit}, item) {
                commit("ADD_DIRTY_FIELD_ITEM", item);
            },
            addDirtyField({commit}, payload) {
                commit("ADD_FIELD_ITEM", payload);
            },
            emptyDirtyItemsFields({commit}) {
                commit("EMPTY_DIRTY_ITEM_FIELDS");
            },
        };

    }
}
